// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/floating_index_model.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/floating_index_model.proto.
 */
export const file_bffportal_v1_floating_index_model: GenFile = /*@__PURE__*/
  fileDesc("CidiZmZwb3J0YWwvdjEvZmxvYXRpbmdfaW5kZXhfbW9kZWwucHJvdG8SDGJmZnBvcnRhbC52MSJcChFGbG9hdGluZ0luZGV4SXRlbRIZChFmbG9hdGluZ19pbmRleF9pZBgBIAEoCRIbChNmbG9hdGluZ19pbmRleF9jb2RlGAIgASgJEg8KB2Zvcm11bGEYAyABKAlCyAEKEGNvbS5iZmZwb3J0YWwudjFCF0Zsb2F0aW5nSW5kZXhNb2RlbFByb3RvUAFaSmdpdGh1Yi5jb20vZW5lY2hhaW4vZXBvc2l0aW9uLWFwcC9iYWNrZW5kL2dlbi9wcm90by9iZmZwb3J0YWwvdjE7YmZmcG9ydGFsogIDQlhYqgIMQmZmcG9ydGFsLlYxygIMQmZmcG9ydGFsXFYx4gIYQmZmcG9ydGFsXFYxXEdQQk1ldGFkYXRh6gINQmZmcG9ydGFsOjpWMWIGcHJvdG8z");

/**
 * @generated from message bffportal.v1.FloatingIndexItem
 */
export type FloatingIndexItem = Message<"bffportal.v1.FloatingIndexItem"> & {
  /**
   * @generated from field: string floating_index_id = 1;
   */
  floatingIndexId: string;

  /**
   * @generated from field: string floating_index_code = 2;
   */
  floatingIndexCode: string;

  /**
   * @generated from field: string formula = 3;
   */
  formula: string;
};

/**
 * Describes the message bffportal.v1.FloatingIndexItem.
 * Use `create(FloatingIndexItemSchema)` to create a new message.
 */
export const FloatingIndexItemSchema: GenMessage<FloatingIndexItem> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_floating_index_model, 0);

